import React from "react";
import Image from "next/image";

const BannerMobileHFM = () => {
  return (
    <section className="w-full px-0 flex flex-col items-center square_grid_bg">
      <Image
        src="/hire-from-miles/hfm-mob-banner.png"
        alt="Hire From Miles"
        className="w-full"
        width={365}
        height={235}
        priority
      />
      <div className="w-full text-center -mt-24">
        <h1 className="text-[28px] font-bold leading-8 text-[#202852]">
          <span>Connecting</span>
        </h1>
        <p className="text-[#202852] leading-8 text-[28px] font-bold">
          Organizations With The
          <br /> Best Talent Across{" "}
        </p>
        <div className="flex justify-center items-center gap-2 mt-6 font-medium text-[#202852] text-[16px]">
          <span className="text-[#3174d6] font-bold leading-5">Accounting</span>{" "}
          |{" "}
          <span className="text-[#008D82] leading-5 font-bold">Healthcare</span>{" "}
          | <span className="text-[#CA7216] leading-5 font-bold">Business</span>
        </div>
      </div>
      <div className="mt-5 mb-10">
        <div className="banner_card ">
          <div className="flex items-center justify-between text-[#202852] border-[#3174d6]">
            <div>
              <p className="w-[76px] text-center text-[12px] not-italic font-semibold leading-4 tracking-[-0.48px] capitalize mt-2">
                Qualified Professionals
              </p>
              <p className="text-center text-[#CA7216] text-[16px] not-italic font-semibold leading-4 tracking-[-0.64px] mb-2">
                70,000+
              </p>
            </div>
            <div className="grey_divider"></div>
            <div>
              <p className="w-[76px] text-center text-[12px] not-italic font-semibold leading-4 tracking-[-0.48px] capitalize mt-2">
                Corporate Partners
              </p>
              <p className="text-center text-[#CA7216] text-[16px] not-italic font-semibold leading-4 tracking-[-0.64px] mb-2">
                600+
              </p>
            </div>
            <div className="grey_divider"></div>
            <div>
              <p className="w-[76px] text-center text-[12px] not-italic font-semibold leading-4 tracking-[-0.48px] capitalize mt-2">
                University Partners
              </p>
              <p className="text-center text-[#CA7216] text-[16px] not-italic font-semibold leading-4 tracking-[-0.64px] mb-2">
                100+
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerMobileHFM;
